module.exports = __webpack_public_path__ + "img/decimoLavoro.a2453cfa.jpg";